<template src="./index.html"></template>

<script>
import IdCard from "@/components/partials/IdCard/index";

export default {
  name: "ChooseUserModal",
  props: {
    usersList: Array,
    visible: Boolean,
  },
  components: {
    "id-card": IdCard,
  },
  data() {
    return {
      modalVisible: false,
      selectedIndex: null,
      myusersList: [],
    };
  },
  methods: {
    onChange(e) {
      //console.log(e.target.value);
    },
    handleChoose() {
      this.$emit("change", this.usersList[this.selectedIndex]);
    },
    clear() {
      this.selectedIndex = null;
      this.myusersList = [];
    },
  },
  watch: {
    visible: function (newValue, oldValue) {
      this.modalVisible = this.visible;
      if (newValue) this.myusersList = this.usersList;
    },
    modalVisible: function () {
      if (!this.modalVisible) {
        this.clear();
        this.$emit("afterClose");
      }
    },
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
